import { render } from "./payroll-deduction.vue?vue&type=template&id=0bfef9e2"
import script from "./payroll-deduction.vue?vue&type=script&lang=js"
export * from "./payroll-deduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__